import React from 'react'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'
import SvgMeal from '@/src/assets/svgs/collection/meal.svg'
import SvgBag from '@/src/assets/svgs/collection/bag.svg'
import SvgMotorcycle from '@/src/assets/svgs/collection/motorcycle.svg'

type Option = 'dineIn' | 'delivery' | 'takeOut'

interface Props {
    option: Option
}

export default function OptionCard({ option }: Props) {
    const t = useTranslations('delivery-options')

    return (
        <div className={styles.contentCard}>
            <div className={styles.imageOption}>
                {option === "delivery" && <SvgMotorcycle className={styles.motorbikeSvg} />}
                {option === "takeOut" && <SvgBag />}
                {option === "dineIn" && <SvgMeal />}
            </div>
            <div className={styles.descriptionOption}>
                <p className={`font-sm ${styles.optionTitle}`}>{t(option)}</p>
            </div>
        </div>
    )
}
